/**
 * GridSizePanel - Configure keyboard grid size
 * Spec §5.2: Module grid configuration (columns × rows)
 */

import { useConfigStore } from '@/store/configStore';

export function GridSizePanel() {
  const columns = useConfigStore((state) => state.columns);
  const rows = useConfigStore((state) => state.rows);
  const keysPerModule = useConfigStore((state) => state.keysPerModule);
  const moduleRowShift = useConfigStore((state) => state.moduleRowShift);
  const setColumns = useConfigStore((state) => state.setColumns);
  const setRows = useConfigStore((state) => state.setRows);
  const setModuleRowShift = useConfigStore((state) => state.setModuleRowShift);

  const totalKeys = columns * rows * keysPerModule;

  return (
    <>
      {/* Columns input (spec §5.2: 1-8) */}
      <div style={{ marginBottom: '12px' }}>
        <label
          htmlFor="columns-input"
          style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}
        >
          Columns (1-8):
        </label>
        <input
          id="columns-input"
          type="number"
          min="1"
          max="8"
          value={columns}
          onChange={(e) => setColumns(parseInt(e.target.value, 10))}
          style={{
            width: '100%',
            padding: '6px',
            fontSize: '14px',
            border: '1px solid #e9ecef',
            borderRadius: '4px',
          }}
        />
      </div>

      {/* Rows input (spec §5.2: 1-4) */}
      <div style={{ marginBottom: '12px' }}>
        <label
          htmlFor="rows-input"
          style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}
        >
          Rows (1-4):
        </label>
        <input
          id="rows-input"
          type="number"
          min="1"
          max="4"
          value={rows}
          onChange={(e) => setRows(parseInt(e.target.value, 10))}
          style={{
            width: '100%',
            padding: '6px',
            fontSize: '14px',
            border: '1px solid #e9ecef',
            borderRadius: '4px',
          }}
        />
      </div>

      {/* Module type: fixed at 16-key (4x4) */}

      {/* Module Row Shift (hardware dependent) */}
      <div style={{ marginBottom: '12px' }}>
        <label
          htmlFor="module-row-shift-input"
          style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}
        >
          Module Row Shift (-4 to 4):
        </label>
        <input
          id="module-row-shift-input"
          type="number"
          min="-4"
          max="4"
          step="1"
          value={moduleRowShift}
          onChange={(e) => setModuleRowShift(parseInt(e.target.value, 10))}
          style={{
            width: '100%',
            padding: '6px',
            fontSize: '14px',
            border: '1px solid #e9ecef',
            borderRadius: '4px',
          }}
        />
        <div style={{ marginTop: '4px', fontSize: '12px', color: '#6c757d' }}>
          Additional Q-axis offset per module row (0 = default hardware, fixed -2 always applied)
        </div>
      </div>

      {/* Summary */}
      <div
        style={{
          padding: '10px 12px',
          backgroundColor: '#e9ecef',
          borderRadius: '6px',
          fontSize: '13px',
        }}
      >
        <div>
          <strong>Grid:</strong> {columns} × {rows} modules
        </div>
        <div>
          <strong>Total Keys:</strong> {totalKeys} ({keysPerModule} keys per module)
        </div>
      </div>
    </>
  );
}
